import { render, staticRenderFns } from "./CustomerItem.vue?vue&type=template&id=65fc2c86&scoped=true"
import script from "./CustomerItem.vue?vue&type=script&lang=ts"
export * from "./CustomerItem.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65fc2c86",
  null
  
)

export default component.exports